import {
  createClient,
  getAllClient,
  getClient,
  deleteClient,
  updateClient,
  updateClientAccess,
  getClientDetailsByLoginToken,
} from "../requests/organization";

import {
  setCreateClient,
  setClientDetailsById,
  setDeleteClientDetailsById,
  setUpdateClientAccess,
  setAllClientUnderSysAdmin,
  setUpdateClient,
  setLoaderState,
  getAllClientUnderSysAdmin,
} from "../../ducks/organization";
import { call, put } from "redux-saga/effects";
import { Authentication } from "../../../utils/authentication";
import { setUserAuthentication, setUserForbidden } from "../../ducks/auth";
import { showToastMessage } from "../../../utils/toastMsg";
import { getUserDetailsByToken } from "../../ducks/user";

export function* handleCreateClient(action) {
  try {
    yield put(setLoaderState(true));
    const response = yield call(createClient, action.payload);
    const { data } = response;
    yield put(setCreateClient({ ...data }));
    yield put(getAllClientUnderSysAdmin());
    yield put(setLoaderState(false));
  } catch (error) {
    yield put(setLoaderState(false));
    if (error?.response?.status === 401) {
      yield put(setUserAuthentication(false));
      Authentication();
    }
    if (error?.response?.status === 403) {
      yield put(setUserForbidden(true));
    }
    if (error?.response?.status === 400) {
      showToastMessage("error", error.response.data.error.errorMessages[0]);
    }
  }
}

export function* handleUpdateClient(action) {
  try {
    yield put(setLoaderState(true));
    const response = yield call(updateClient, action.payload);
    const { data } = response;
    yield put(setUpdateClient({ ...data }));
    yield put(getUserDetailsByToken());
    yield put(setLoaderState(false));
  } catch (error) {
    yield put(setLoaderState(false));
    if (error?.response?.status === 401) {
      yield put(setUserAuthentication(false));
      Authentication();
    }
    if (error?.response?.status === 403) {
      yield put(setUserForbidden(true));
    }
    if (error?.response?.status === 400) {
      showToastMessage("error", error.response.data.error.errorMessages[0]);
    }
  }
}
export function* handleGetAllClients(action) {
  try {
    yield put(setLoaderState(true));
    const response = yield call(getAllClient, action.payload);
    const { data } = response;
    yield put(setAllClientUnderSysAdmin({ ...data }));
    yield put(setLoaderState(false));
  } catch (error) {
    yield put(setLoaderState(false));
    if (error?.response?.status === 401) {
      yield put(setUserAuthentication(false));
      Authentication();
    }
    if (error?.response?.status === 403) {
      yield put(setUserForbidden(true));
    }
    if (error?.response?.status === 400) {
      showToastMessage("error", error.response.data.error.errorMessages[0]);
    }
  }
}
export function* handleGetClient(action) {
  try {
    yield put(setLoaderState(true));
    const response = yield call(getClient, action.payload);
    const { data } = response;
    yield put(setClientDetailsById({ ...data }));
    yield put(setLoaderState(false));
  } catch (error) {
    yield put(setLoaderState(false));
    if (error?.response?.status === 401) {
      yield put(setUserAuthentication(false));
      Authentication();
    }
    if (error?.response?.status === 403) {
      yield put(setUserForbidden(true));
    }
    if (error?.response?.status === 400) {
      showToastMessage("error", error.response.data.error.errorMessages[0]);
    }
  }
}
export function* handleGetClientByToken() {
  try {
    yield put(setLoaderState(true));
    const response = yield call(getClientDetailsByLoginToken);
    const { data } = response;
    yield put(setClientDetailsById({ ...data }));
    yield put(setLoaderState(false));
  } catch (error) {
    yield put(setLoaderState(false));
    if (error?.response?.status === 401) {
      yield put(setUserAuthentication(false));
      Authentication();
    }
    if (error?.response?.status === 403) {
      yield put(setUserForbidden(true));
    }
    if (error?.response?.status === 400) {
      showToastMessage("error", error.response.data.error.errorMessages[0]);
    }
  }
}
export function* handleDeleteClient(action) {
  try {
    yield put(setLoaderState(true));
    const response = yield call(deleteClient, action.payload);
    const { data } = response;
    yield put(setDeleteClientDetailsById({ ...data }));
    yield put(getAllClientUnderSysAdmin());
    yield put(setLoaderState(false));
  } catch (error) {
    yield put(setLoaderState(false));
    if (error?.response?.status === 401) {
      yield put(setUserAuthentication(false));
      Authentication();
    }
    if (error?.response?.status === 400) {
      showToastMessage("error", error.response.data.error.errorMessages[0]);
    }
  }
}
export function* handleUpdateClientAccess(action) {
  try {
    yield put(setLoaderState(true));
    const response = yield call(updateClientAccess, action.payload);
    const { data } = response;
    yield put(setUpdateClientAccess({ ...data }));
    yield put(setLoaderState(false));
    yield put(getAllClientUnderSysAdmin());
  } catch (error) {
    yield put(setLoaderState(false));
    if (error?.response?.status === 401) {
      yield put(setUserAuthentication(false));
      Authentication();
    }
    if (error?.response?.status === 403) {
      yield put(setUserForbidden(true));
    }
    if (error?.response?.status === 400) {
      showToastMessage("error", error.response.data.error.errorMessages[0]);
    }
  }
}
